const scriptTagId = 'ossdk-script-tag'

export const loadSdkScript = async (osScriptLocation, osSdkKey, extraScriptParams, sdkConfig) => {
  if (window.ossdk) {
    console.warn('Changing extraScriptParams after first script load will not be applied.')
    console.warn('running loadSdkScript again but script already loaded. ignore', window.ossdk)
    return Promise.resolve(window.ossdk)
  }
  const scriptTag = document.getElementById(scriptTagId)
  if (!scriptTag) {
    const scriptTag = document.createElement('script')
    scriptTag.setAttribute('id', scriptTagId)
    scriptTag.src = osScriptLocation
    document.body.append(scriptTag)
  }

  let config = {
    key: osSdkKey,
  }

  // REMOVE THIS SECTION WHEN 3RD PARTIES ARE READY, SEE #15888
  if(typeof extraScriptParams === 'string') {
    const params = new URLSearchParams(extraScriptParams)
    params.forEach((value, key) => {
      const key_lower = key.toLowerCase()
      if (key_lower in InjectableConfigKeys) {
        setConfigValue(key_lower, config, value)
      } else {
        setConfigValue(key, config, value)
      }
    })
  }
  // END REMOVE THIS SECTION 
  
  if(sdkConfig) {
    config = {
      ...sdkConfig,
      ...config,
    }
  }


  const ossdk = await initSdk(config)
  return await awaitSdkReadiness(ossdk)
}

// REMOVE THIS SECTION WHEN 3RD PARTIES ARE READY, SEE #15888
const setConfigValue = (key, config, value) => {
  /*  
  @TODO: Find a better way to indicate that this should be parsed as JSON before injecting into loginConfig
  currently it is hard-coded during parsing.
  */
  if (value === 'true') config[key] = true
  else if (value === 'false') config[key] = false
  else if (keysToParseAsJson.includes(key)) config[key] = JSON.parse(value)
  else if (value === parseFloat(value) + '') config[key] = parseFloat(value)
  else config[key] = value
}
export const InjectableConfigKeys = [
  'key',
  'parent',
  'automount',
  'automount_secs',
  'singleton',
  'env',
  'hostname_spa',
  'login_configs_override',
  'signals',
  'map_types_block',
  'view_overrides',
  'permissions_block',
  'design_permission_overrides',
]
export const keysToParseAsJson = [
  'login_configs_override',
  'signals',
  'map_types_block',
  'permissions_block',
  'design_permission_overrides',
  'view_overrides',
]
// END REMOVE THIS SECTION 


export const awaitSdkReadiness = (ossdk) => {
  return new Promise((resolve, reject) => {
    if (ossdk.isReady.value) {
      resolve(ossdk)
    } else {
      const callback = (value) => {
        if (!value) return
        resolve(ossdk)
        ossdk.isReady.remove(callback)
      }
      ossdk.isReady.add(callback)
    }
  })
}

export const initSdk = (config) => {
  async function doInit() {
    let sdk = await window.initOpenSolar(config)
    if(window.onOpenSolarReady) window.onOpenSolarReady(sdk)
    return sdk
  }
  return new Promise((resolve, reject) => {
    if (window.initOpenSolar) {
      doInit().then(resolve).catch(reject)
      return
    }
    waitForElement(document.body, scriptTagId).then((scriptTag) => {
      const cleanup = () => {
        scriptTag.removeEventListener('load', onLoad)
        scriptTag.removeEventListener('error', onError)
      }
      const onLoad = () => {
        cleanup()
        doInit().then(resolve).catch(reject)
      }
      const onError = () => {
        cleanup()
        reject(new Error('Failed to load OpenSolar SDK script'))
      }
      scriptTag.addEventListener('load', onLoad)
      scriptTag.addEventListener('error', onError)
    })
  })
}

export const resolveSdk = () => {
  return new Promise((resolve, reject) => {
    if (window.ossdk) {
      resolve(window.ossdk)
      return
    }
    const origReadyFunc = window.onOpenSolarReady
    window.onOpenSolarReady = (sdk) => {
      origReadyFunc && origReadyFunc(sdk)
      resolve(sdk)
    }
  })
}

// Warning: waits forever for the element to appear, never gets rejected
const waitForElement = (parent, id) => {
  return new Promise((resolve, reject) => {
    const element = document.getElementById(id)
    if (element) {
      resolve(element)
      return
    }

    const config = { childList: true }

    const callback = (mutationList, observer) => {
      for (const mutation of mutationList) {
        if (mutation.type === 'childList') {
          const element = document.getElementById(id)
          if (element) {
            resolve(element)
            observer.disconnect()
          }
        }
      }
    }

    // eslint-disable-next-line no-undef
    const observer = new MutationObserver(callback)
    observer.observe(parent, config)
  })
}

const STUDIO_SIGNAL_NAMES = [
  'windowResize',
  'objectSelected',
  'objectAdded',
  'objectChanged',
  'objectRemoved',
  'sceneLoaded',
  'queueProcessed'
]

export const clearSignalHandlers = (ossdk) => {
  if (ossdk) {
    STUDIO_SIGNAL_NAMES.forEach((signalName) => {
      while (ossdk.studio[signalName]?.handlers.length > 0) {
        ossdk.studio[signalName].remove(ossdk.studio[signalName].handlers[0])
      }
    })
  } else {
    console.warn('clearSignalHandlers called with missing ossdk reference', ossdk)
  }
}
